export default {
  STANDARD: 'direction-standard',
  REVERSE: 'direction-reverse'
};